import styles from './period-switcher.module.css';

type PeriodSwitcherProps = {
  label: string;
  previousLabel: string;
  nextLabel: string;
  onPrevious: () => void;
  onNext: () => void;
};

/**
 * The control row of a screen that shows one period at a time - a year, a month. Sized like the
 * segmented control so every top-level screen keeps the same second row.
 */
export const PeriodSwitcher = ({
  label,
  previousLabel,
  nextLabel,
  onPrevious,
  onNext,
}: PeriodSwitcherProps) => (
  <div className={styles.switcher}>
    <button type="button" className={styles.button} aria-label={previousLabel} onClick={onPrevious}>
      ‹
    </button>
    <span className={styles.label} aria-live="polite">
      {label}
    </span>
    <button type="button" className={styles.button} aria-label={nextLabel} onClick={onNext}>
      ›
    </button>
  </div>
);
